import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface PageContainerProps {
    children: ReactNode
    className?: string
    size?: 'default' | 'narrow'
}

const PageContainer: FC<PageContainerProps> = ({ children, className, size = 'default' }): ReactNode => {
    return (
        <div
            className={cn(
                'mx-auto w-full px-4 pt-5 pb-10 sm:px-6 lg:px-8 lg:pt-8',
                size === 'narrow' ? 'max-w-5xl' : 'max-w-7xl',
                className
            )}
        >
            {children}
        </div>
    )
}

export default PageContainer
